"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestController__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_akirAddress",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "AKIR_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINTER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_recipients",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "batchMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TestController__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "TestController";
    }
    deploy(_akirAddress, overrides) {
        return super.deploy(_akirAddress, overrides || {});
    }
    getDeployTransaction(_akirAddress, overrides) {
        return super.getDeployTransaction(_akirAddress, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TestController__factory = TestController__factory;
TestController__factory.bytecode = _bytecode;
TestController__factory.abi = _abi;
